"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.TranslationReducer = undefined;
exports.registerTranslation = registerTranslation;

var _TranslateActions = require("../actions/TranslateActions");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _TranslationMultipleRegister = require("../actions/TranslationMultipleRegister");

var _TranslationReducer_InitialState = require("./TranslationReducer_InitialState");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TranslationReducer = exports.TranslationReducer = function TranslationReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _TranslationReducer_InitialState.TranslationReducer_InitialState;
	var action = arguments[1];

	switch (action.type) {
		case _TranslationMultipleRegister.TRANSLATION_MULTIPLE_REGISTER_SUCCESS:
			return _lodash2.default.merge({}, state, { allTranslations: action.payload.tr });

		case _TranslateActions.TRANSLATION_REGISTER_SUCCESS:
			return registerTranslation(state, action.payload.path, action.payload.data);

		case _TranslateActions.TRANSLATION_SET_AVAILABLE_LANGUAGES_SUCCESS:
			return Object.assign({}, state, {
				availableLanguages: action.listLC
			});

		case _TranslateActions.TRANSLATION_CHANGE_LANGUAGE_SUCCESS:
			return Object.assign({}, state, {
				activeLanguage: action.LC
			});

		default:
			return state;
	}
};

function registerTranslation(tr, path, data) {
	return _lodash2.default.merge({}, { allTranslations: _lodash2.default.merge({}, tr.allTranslations, _lodash2.default.setWith({}, _lodash2.default.toPath(path), data, Object)) });
}